import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { CenteredContainer, Title } from '@nerdwallet/currency';

import Hero from '../employee-branding/hero/hero';
import CompanyPeople from '../employee-branding/company-people/company-people';

import CompanyExecutiveContent from '../../lib/employee-branding/executives';

import Spacer from '../spacer/spacer';

const LeadershipPage = () => (
  <React.Fragment>
    <div
      className={classNames([
        classes('margin-bottom-4'),
        classes('margin-bottom-5--wide'),
      ])}
    >
      <Hero
        backgroundColor="#EEF7FF"
        title="Leadership at NerdWallet"
        copy="Our leaders have crafted a culture where every Nerd can make a lasting impact. Their commitment to ownership and growth sets the stage for teams to chase individual opportunities while pushing NerdWallet forward."
        imageUrlMobile="https://www.nerdwallet.com/cdn/company/2021/hero/Leadership-Hero-Mobile.jpg"
        imageUrlDesktop="https://www.nerdwallet.com/cdn/company/2021/hero/Leadership-Hero-Desktop.jpg"
      />
    </div>
    <div>
      <CenteredContainer>
        <Title
          size="small"
          chronicle
          className={classNames([
            classes('margin-horizontal-auto'),
            classes('margin-bottom-3'),
            classes('margin-bottom-4--wide'),
            classes('text-align-center'),
          ])}
          component="h2"
        >
          Our executive team
        </Title>
      </CenteredContainer>
      <CompanyPeople isSpecialist={false} {...CompanyExecutiveContent} />
      <Spacer ndsMarginClass="3" />
    </div>
  </React.Fragment>
);

LeadershipPage.displayName = 'Leadership Page';

export default LeadershipPage;
